'use client';

import { CircularSpinnerß } from '@otter-ai/den-components';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { PATH_URL } from '@/constants/path-constants';
import { TemplateList } from '@/features/account-settings/personal-templates/components/TemplateList';
import { templatesQueryCreator } from '@/features/account-settings/personal-templates/query/templatesQueryCreator';
import { ContentContainer } from '@/features/account-settings/shared/components/ContentContainer';
import { useManageTeamPageAccess } from '@/features/manage-team/components/useManageTeamPageAccess';

export default function TemplatesPage() {
  const tCommon = useTranslations('common');
  const { hasAccess, isLoading: isAccessLoading } = useManageTeamPageAccess(
    PATH_URL.TEAM_TEMPLATES,
  );
  const { data: templates, isLoading } = useQuery(
    templatesQueryCreator('workspace'),
  );

  if (isAccessLoading || isLoading) {
    return (
      <div className="flex justify-center py-16">
        <CircularSpinnerß size="lg" data-testid="templates-loading-spinner" />
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <h2 className="text-xl font-semibold mb-2">
          {tCommon('accessDenied.title')}
        </h2>
        <p className="text-muted text-center">
          {tCommon('accessDenied.message')}
        </p>
      </div>
    );
  }

  if (!templates) {
    return (
      <div className="flex justify-center py-16">
        <CircularSpinnerß size="lg" data-testid="templates-loading-spinner" />
      </div>
    );
  }
  return (
    <ContentContainer>
      <div className="font-semibold text-lg">Workspace Templates</div>
      <TemplateList
        type="admin"
        templates={templates?.data.templates ?? []}
        canCreateTemplate={
          templates?.data.permissions.can_create_workspace_templates
        }
      />
    </ContentContainer>
  );
}
